import { Resource as ResourceType } from '../types';

export const client: ResourceType = {
  name: 'clients',
  label: 'resource.clients.label',
  hideResource: false,
  attributes: [
    {
      key: 'id',
      label: 'resource.users.field.id.label',
      type: 'text',
    },
    {
      key: 'company_id',
      label: 'resource.users.field.company_id.label',
      type: 'reference',
      reference: 'companies',
    },
    {
      key: 'first_name',
      label: 'resource.users.field.first_name.label',
      type: 'text',
    },
    {
      key: 'last_name',
      label: 'resource.users.field.last_name.label',
      type: 'text',
    },
    {
      key: 'company_name',
      label: 'resource.users.field.company_name.label',
      type: 'text',
    },
    {
      key: 'email',
      label: 'resource.users.field.email.label',
      type: 'email',
    },
    {
      key: 'phone',
      label: 'resource.users.field.phone.label',
      type: 'phone',
    },
    {
      key: 'company_practice_culture',
      label: 'resource.companies.field.practice_culture.label',
      type: 'multipleSelect',
      choices: [
        {
          id: 'big_4_and_similar',
          name: 'resource.companies.field.practice_culture.choices.big_4_and_similar',
        },
        {
          id: 'anglo_saxon_firms',
          name: 'resource.companies.field.practice_culture.choices.anglo_saxon_firms',
        },
        {
          id: 'french_international_business_law_firm',
          name: 'resource.companies.field.practice_culture.choices.french_international_business_law_firm',
        },
        {
          id: 'full_service_law_firm_over_50',
          name: 'resource.companies.field.practice_culture.choices.full_service_law_firm_over_50',
        },
        {
          id: 'full_service_law_firm_under_50',
          name: 'resource.companies.field.practice_culture.choices.full_service_law_firm_under_50',
        },
        {
          id: 'specialized_law_firm',
          name: 'resource.companies.field.practice_culture.choices.specialized_law_firm',
        },
        {
          id: 'general_practice_law_firm',
          name: 'resource.companies.field.practice_culture.choices.general_practice_law_firm',
        },
        {
          id: 'council_of_state_law_firm',
          name: 'resource.companies.field.practice_culture.choices.council_of_state_law_firm',
        },
        {
          id: 'individual_law_practitioner',
          name: 'resource.companies.field.practice_culture.choices.individual_law_practitioner',
        },
        {
          id: 'legal_department_of_a_french_company',
          name: 'resource.companies.field.practice_culture.choices.legal_department_of_a_french_company',
        },
        {
          id: 'legal_department_of_an_international_company',
          name: 'resource.companies.field.practice_culture.choices.legal_department_of_an_international_company',
        },
      ],
    },
    {
      key: 'job_name',
      label: 'resource.users.field.job_name.client.label',
      type: 'text',
    },
    {
      key: 'anonymized',
      label: 'resource.users.field.anonymized.label',
      type: 'boolean',
    },
    {
      key: 'blocked',
      label: 'resource.users.field.blocked.label',
      type: 'boolean',
    },
    {
      key: 'is_registered',
      label: 'resource.users.field.is_registered.label',
      type: 'boolean',
    },
    {
      key: 'cgu_accepted_at',
      label: 'resource.users.field.cgu_accepted_at.label',
      type: 'date',
    },
    {
      key: 'created_at',
      label: 'resource.users.field.created_at.label',
      type: 'date',
    },
    {
      key: 'updated_at',
      label: 'resource.users.field.updated_at.label',
      type: 'date',
    },
    {
      key: 'last_signin_at',
      label: 'resource.users.field.last_signin_at.label',
      type: 'date',
    },
    {
      key: 'administrator',
      label: 'resource.users.field.administrator.label',
      type: 'boolean',
    },
  ],
  pages: {
    list: {
      hasEditButton: true,
      hasCreateButton: true,
      editAndCreateBasePath: '/users',
      exportKindType: 'client',
      search: {
        enabled: true,
        label: 'filter.search.label',
      },
      extensions: [],
      bulkActionButtons: [
        {
          name: 'validate',
          type: 'update',
          label: 'resource.users.bulk_action_buttons.validate.label',
          values: {
            validated: true,
          },
        },
        {
          name: 'unvalidate',
          type: 'update',
          label: 'resource.users.bulk_action_buttons.unvalidate.label',
          values: {
            validated: false,
          },
        },
        {
          name: 'block',
          type: 'update',
          label: 'resource.users.bulk_action_buttons.block.label',
          icon: 'Lock',
          values: {
            blocked: true,
          },
        },
        {
          name: 'unblock',
          type: 'update',
          label: 'resource.users.bulk_action_buttons.unblock.label',
          icon: 'LockOpen',
          values: {
            blocked: false,
          },
        },
        {
          name: 'anonymize',
          type: 'update',
          label: 'resource.users.bulk_action_buttons.anonymize.label',
          values: {},
          extraUrl: '/anonymize',
          icon: 'VisibilityOff',
          // Following settings are only useful for update with confirmation
          withConfirmation: true,
          confirmation: {
            content: 'modal.bulk_anonymize.content',
          },
        },
      ],
      filters: [
        {
          source: 'blocked',
        },
        {
          source: 'administrator',
        },
        {
          source: 'company_id',
          type: 'reference',
          child: {
            type: 'autocomplete',
            // Options to pass to ReferenceInput
            options: {
              perPage: 10,
              allowEmpty: false,
            },
          },
        },
        {
          source: 'company_practice_culture',
          optionsFilter: {
            className: 'multipleSelectFilter',
          },
        },
        {
          source: 'anonymized',
        },
        {
          source: 'created_at',
          type: 'dateRange',
          label: 'resource.users.field.created_at.label',
        },
        {
          source: 'last_signin_at',
          type: 'dateRange',
          label: 'resource.users.field.last_signin_at_filter.label',
        },
        {
          source: 'updated_at',
          type: 'dateRange',
          label: 'resource.users.field.updated_at_filter.label',
        },
      ],
      fields: [
        {
          source: 'first_name',
          sortable: true,
        },
        {
          source: 'last_name',
          sortable: true,
        },
        {
          source: 'email',
          sortable: true,
        },
        {
          source: 'phone',
          sortable: false,
        },
        {
          source: 'company_practice_culture',
          type: 'array',
          translationPrefix:
            'resource.companies.field.practice_culture.choices',
          sortable: false,
        },
        {
          source: 'job_name',
        },
        {
          source: 'blocked',
          sortable: false,
        },
        {
          source: 'is_registered',
        },
        {
          source: 'cgu_accepted_at',
          sortable: false,
        },
        {
          source: 'created_at',
        },
      ],
    },
    edit: {
      left: {
        tabs: [],
      },
      right: [],
    },
  },
};
